import { useContext, useEffect } from 'react'

import { TrackingContext } from 'Contexts/TrackingContext/TrackingContext'

const Ga4ContentGroup = ({ contentGroup }) => {
  const trackingContext = useContext(TrackingContext)

  useEffect(() => {
    trackingContext.setGa4ContentGroup(contentGroup)
  }, [])
}

export default Ga4ContentGroup
